import React from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { INACTIVITY_STATE, InactivityTimeout, IS_WEB, Modal } from '../..'

export interface InactivityWarningModalProps {
  visible: boolean
  onRequestClose: () => void
  warningDuration: number
  onPressResume: () => void
  onPressSignIn: () => void
  onPressSignOut: () => void
  onWarningTimeUp: () => void
  onPressClose?: () => void
  inactivityState?: INACTIVITY_STATE
  animationType?: 'none' | 'slide' | 'fade'
}

export const InactivityWarningModal: React.FunctionComponent<InactivityWarningModalProps> = ({
  visible,
  onRequestClose,
  warningDuration,
  onPressResume,
  onPressSignIn,
  onPressSignOut,
  onWarningTimeUp,
  onPressClose,
  inactivityState,
  animationType = 'fade',
}) => {
  const { breakpoints } = useTheme()
  const { formatMessage } = useIntl()

  return (
    <Modal
      visible={visible}
      onRequestClose={onRequestClose}
      animationType={animationType}
      width='100%'
      showCloseIcon={false}
      useDynamicHeightForBottomSheet
      accessibilityLabel={formatMessage({
        defaultMessage: 'Inactivity warning modal',
        description: 'Accessibility label for inactivity warning modal',
      })}
      modalContents={
        <InactivityTimeout
          warningDuration={warningDuration}
          onPressResume={onPressResume}
          onPressSignIn={onPressSignIn}
          onPressSignOut={onPressSignOut}
          onWarningTimeUp={onWarningTimeUp}
          onPressClose={onPressClose}
          isWeb={IS_WEB}
          showClose={breakpoints.isMinWidthTablet}
          inactivityState={inactivityState}
        />
      }
    />
  )
}
